import { Panel } from '../../components/ui';

export function DeniedState() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-surface px-4">
      <Panel className="relative w-full max-w-md overflow-hidden p-8 text-center">
        <div
          aria-hidden="true"
          className="absolute -top-16 left-1/2 h-40 w-40 -translate-x-1/2 rounded-full bg-accent-gradient opacity-20 blur-3xl"
        />
        <div className="relative flex flex-col items-center gap-3">
          <h1 className="font-sans text-xl font-semibold text-body">Access paused</h1>
          <p className="text-sm text-muted">
            Your account access has been paused. If you believe this is a mistake, reach out and
            we'll take a look.
          </p>
          <a
            href="mailto:hello@flowcraftr.com"
            className="text-sm font-medium text-accent hover:underline"
          >
            hello@flowcraftr.com
          </a>
        </div>
      </Panel>
    </div>
  );
}
